import { all, fork } from 'redux-saga/effects';

import feedbacks from './feedbacksSagas';
import bookmarks from './bookmarksSagas';
import jwt_decode from 'jwt-decode';
import moment from 'moment';
import config from 'react-global-configuration';

/**
 * rootSaga
 */
export default function* root() {
  yield all([fork(feedbacks), fork(bookmarks)]);
}

export function request(url, config) {
  const token = localStorage.getItem('QUSER');
  if (!validateToken(token)) {
    throw 'Unauthorized.';
  }
  const headers = {
    Accept: config.type,
    'Content-Type': 'application/json',
    'X-Client-id': 'feedbackAdmin',
    Authorization: `Bearer ${token}`,
    ...config.headers,
  };
  const options = {
    headers,
    method: config.method,
    body: config.body,
  };

  return fetch(url, options)
    .then(function (response) {
      const newToken = response.headers.get('X-Auth-token');
      if (newToken) {
        localStorage.setItem('QUSER', newToken);
      }
      if (config.complete) {
        return response;
      } else if (config.type === 'application/json') {
        return response.json();
      } else if (config.type === 'text/plain') {
        return response.text();
      } else {
        return response.blob();
      }
      // Your code for handling the data you get from the API
    })
    .catch(function (error) {
      // This is where you run code if the server returns any errors
      throw error;
    });
}

export function validateToken(token) {
  if (!token) {
    window.location.href = config.get('login');
    return false;
  }
  const decoded = jwt_decode(token);
  let expire = decoded.exp;
  expire = moment.unix(expire);
  if (expire.isBefore()) {
    window.location.href = config.get('login');
    return false;
  }
  return true;
}
